import { ProgramClass } from '@/models/ProgramClass';
import { ApplicationState } from '@/store';
import { getCourseRequest } from '@/store/list/action';
import { createProgramClassForCourseRequest } from '@/store/programClass/actions';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import _ from 'underscore';
import Classes from '../../../Classes';

const CourseClasses: React.FC = () => {
    const { course, orgId, programClassCreatedSuccess, newProgramClassId } = useSelector((state: ApplicationState) => ({
        course: state.lists.courseData,
        orgId: state.identity.data.user.orgId,
        programClassCreatedSuccess: state.programClass.success,
        newProgramClassId: _.last(state.programClass.data)?.id,
    }));

    const [addingNewClass, setAddingNewClass] = useState<boolean>(false);

    const dispatch = useDispatch();
    const history = useHistory();

    const courseId: number = parseInt(useParams<{ id: string }>().id);

    const onAddClickHandler = () => {
        setAddingNewClass(true);
        dispatch(createProgramClassForCourseRequest({ courseId, name: '', orgId } as ProgramClass));
    };

    useEffect(() => {
        if (addingNewClass && programClassCreatedSuccess && newProgramClassId) {
            history.push(`${history.location.pathname}/${newProgramClassId}`);
        }
    }, [addingNewClass, programClassCreatedSuccess, newProgramClassId]);

    useEffect(() => {
        dispatch(getCourseRequest(courseId));
    }, [dispatch, courseId]);

    return (
        <Classes
            entity={{
                id: courseId,
                name: course.name,
                locale: course.locale,
                rootPath: '/contents/lms/courses',
                status: course.status,
                classType: 'COURSE',
                courseType: course.type,
            }}
            onAddClickHandler={onAddClickHandler}
        />
    );
};

export default CourseClasses;
